(function() {
  'use strict';

  angular
    .module('teloneumUi', 
      [
        'ngAnimate', 
        'ngCookies', 
        'ngTouch', 
        'ngSanitize', 
        'ngMessages', 
        'ngAria', 
        'ui.router', 
        'ui.bootstrap', 
        'toastr',
        'jsonFormatter'
      ]
    );

})();

(function() {
    'use strict';
  
    angular
      .module('teloneumUi')
      .component('teloRoutingTable', {
          templateUrl: 'app/components/routing/routingTable/routingTable.html',
          controller: 'RoutingTableController as vm',
          bindings: {            
            routeResponse: '='
          }
      });

    angular
      .module('teloneumUi')
      .controller('RoutingTableController', RoutingTableController)
  
    /** @ngInject */
    function RoutingTableController($log) {
      $log.info('RoutingTableController');
    }
  
  })();
  
(function() {
    'use strict';

    angular
      .module('teloneumUi')
      .component('teloRoutingSummary', {
          templateUrl: 'app/components/routing/routingSummary/routingSummary.html',
          controller: 'RoutingSummaryController as vm',
          bindings: {
            routeResponse: '='
          }
      });

    angular
      .module('teloneumUi')
      .controller('RoutingSummaryController', RoutingSummaryController)

    /** @ngInject */
    function RoutingSummaryController($log, routingConstants, routingService, $scope) {
        var vm = this;
        vm.labels = routingConstants.routeSummary.labels;

        $scope.$watch("vm.routeResponse", function(){
          if(angular.isDefined(vm.routeResponse)){
            var tradeSummary = routingService.formatResponseForSummary(vm.routeResponse);
            $log.info('tradeSummary', tradeSummary);
            vm.summary = tradeSummary;
          }
        });
    }

  })();

(function () {
  'use strict';

  angular
    .module('teloneumUi')
    .component('teloRoutingForm', {
      templateUrl: 'app/components/routing/routingForm/routingForm.html',
      controller: 'RoutingFormController as vm',
      bindings: {
        //inputs: '=',
        //routeOrder: '&',
        routeResponse: '='
      }
    });

  angular
    .module('teloneumUi')
    .controller('RoutingFormController', RoutingFormController)

  /** @ngInject */
  function RoutingFormController($log, $loadingService, routingService) {
    var vm = this;

    vm.inputs = {
      source: 'BTC',
      dest: 'USD',
      size: .5
    };

    routingService.getEnvironments().then(function (response) {
      vm.environmentOptions = response;
      var defaultEnvironment = routingService.getDefaultEnvironment(response);
      vm.inputs.environmentId = defaultEnvironment.environmentId;
      vm.changeEnvironment();
    });

    vm.changeEnvironment = function () {
      $log.info('environment', vm.inputs.environmentId);

      if (vm.inputs.environmentId !== "custom") {
        vm.inputs.environment = vm.inputs.environmentId;
      } else {
        vm.inputs.environment = "";
      }
    };

    vm.routeOrder = function () {
      var start = new Date();

      var extraArgs = {};
      try {
        extraArgs = angular.fromJson(vm.inputs.arguments);
      } catch (e) {
        $log.error('Extra Args Incorrect format', e);
      }
      $log.info('Route Order', extraArgs);

      $loadingService.setIsLoading(true);

      routingService.routeOrder(vm.inputs.source, vm.inputs.dest, vm.inputs.size, vm.inputs.environment, extraArgs).then(function (routeResponse) {
        $log.info('routeResponse', routeResponse);
        routeResponse.destination = vm.inputs.dest.toUpperCase();
        routeResponse.timestamp = new Date();
        routeResponse.timeToCalculate = routeResponse.timestamp - start;

        //deconstructResponseIntoViewModel(routeResponse, vm);
        vm.routeResponse = routeResponse;

        // Note : Consider calling the summary aggregate here to eliminate the watch in the summary component

        $loadingService.setIsLoading(false);
      });
    };

    vm.openAdvancedRouteModal = function () {
      var modalInstance = routingService.openAdvancedRouteModal();
      modalInstance.result.then(function () {
        var start = new Date();
        routingService.postOrder().then(function (routeResponse) {
          $log.info('routeResponse', routeResponse);
          routeResponse.destination = vm.inputs.dest.toUpperCase();
          routeResponse.timestamp = new Date();
          routeResponse.timeToCalculate = routeResponse.timestamp - start;

          vm.routeResponse = routeResponse;

          $loadingService.setIsLoading(false);
        })
      })
    };

    $log.info('Loading Routing Form Cotroller', vm.inputs);
  }
})();

(function () {
  'use strict';


  angular
    .module('teloneumUi')
    .controller('AdvancedRouteModalController', AdvancedRouteModalController)

  /** @ngInject */
  function AdvancedRouteModalController($uibModalInstance, $userPreference) {
    var vm = this;

    vm.$onInit = function () {
      vm.advancedRouteBody = $userPreference.getPreference('advancedRouteBody');
      if (!vm.advancedRouteBody) {
        vm.advancedRouteBody = null;
      }
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    };

    vm.saveAdvancedRoute = function () {
      $userPreference.setPreference('advancedRouteBody', vm.advancedRouteBody);
      $uibModalInstance.close();
    };

  }
})();

(function() {
    'use strict';
  
    angular
      .module('teloneumUi')
      .component('teloLoginForm', {
          templateUrl: 'app/components/login/loginForm/loginForm.html',
          controller: 'LoginFormController as vm',
          bindings: {

          }
      });

    angular
      .module('teloneumUi')
      .controller('LoginFormController', LoginFormController)
  
    /** @ngInject */
    function LoginFormController($log, $state, $loadingService, loginService, sha256, toastr) {
      var vm = this;
      vm.disableSubmit = false;

      $log.info('LoginFormController');

      var getLoginParams = function(){
        return {
          email: vm.email,
          passwordSha256: sha256(vm.password)
        };
      };

      var handleLoginErrors = function(loginResponse){
        
        $log.info('Error Logging In', loginResponse);

        if(loginResponse === null){
          toastr.error('Login Error: Request timed out');
        }
      };

      vm.login = function(){
        vm.disableSubmit = true;
        if(vm.loginForm.$valid) {
          var credentials = getLoginParams();          
          loginService.loginUser(credentials).then(function(loginResponse){
            var userIsAuthenticated = loginService.userIsAuthenticated();
            $log.info('userIsAuthenticated LoginFormController', userIsAuthenticated);            
            if(userIsAuthenticated) {
              $state.go('demo');
            }
            else {              
              handleLoginErrors(loginResponse);                            
              vm.disableSubmit = false;
            }
            $loadingService.setIsLoading(false);
          });
        }
        else {
          vm.disableSubmit = false;
        } 
               
      };
    }
  
  })();
  
(function() {
    'use strict';
  
    angular
      .module('teloneumUi')
      .controller('LogoutController', LogoutController);
  
    /** @ngInject */
    function LogoutController($log, loginService) {
      var vm = this;

      $log.info('Logout Page Loaded');
            
      loginService.logoutUser();

      vm.goToLogin = function(){
        $log.info('vm.goToLogin');
        loginService.redirectIfNotAuthenticated();
      };
            
    }
  })();
  
(function() {
    'use strict';
  
    angular
      .module('teloneumUi')
      .controller('LoginController', LoginController);
  
    /** @ngInject */
    function LoginController($log) {
      // var vm = this;

      $log.info('Login Page Loaded');            
    }
  })();
  
(function () {
  'use strict';

  angular
    .module('teloneumUi')
    .controller('DemoController', DemoController);

  /** @ngInject */
  function DemoController($log, routingService) {
    var vm = this;

    vm.routeResponse = {};

    $log.info('Demo Page Loaded');

    vm.executeRoute = function () {
      vm.executionResponse = undefined;
      var executionRequest = routingService.routeResponseToExecutionRequest(vm.routeResponse);
      routingService.postExecution(executionRequest).then(function (response) {
        vm.executionResponse = response;
        $log.info('executionResponse', vm.executionResponse);
      });
    };
  }

})();

(function() {
  'use strict';

  angular
      .module('teloneumUi')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
    'use strict';
  
    angular
      .module('teloneumUi')
      .component('teloTopNavigation', {
          templateUrl: 'app/components/topNavigation/topNavigation.html',
          controller: 'TopNavigationController as vm',
          bindings: {

          }
      });

    angular
      .module('teloneumUi')
      .controller('TopNavigationController', TopNavigationController)
  
    /** @ngInject */
    function TopNavigationController($userPreference) {
      var vm = this;
      
      vm.loggedInUser = $userPreference.getEmail();      
    }
  
  })();
  
(function () {
  'use strict';

  angular
    .module('teloneumUi')
    .service('routingService', routingService);

  /** @ngInject */
  function routingService($log, $http, $uibModal, $userPreference, toastr, environmentService, routingConstants) {

    var apiEnvironment = environmentService.getApiPath();

    function routeOrder(source, dest, size, environment) {
      var url = apiEnvironment + '/api/routing/route?' +
        'source=' + source +
        '&destination=' + dest +
        '&size=' + size +
        '&environmentId=' + environment;

      $log.info('Route Order', url);

      var config = {
        headers: {
          Authorization: 'Bearer ' + $userPreference.getAuthToken()
        }
      };

      return $http.get(url, config).then(
        function successCallback(routeResponse) {
          return routeResponse.data;
        },
        function errorCallback(routeResponseError) {
          $log.error('routeResponseError', routeResponseError);
          toastr.error(routeResponseError.status + ': Error Fetching Response');

          // Unauthorized
          if (routeResponseError.status === 401) {
            $userPreference.clearLoginInfo();
          }
          return routeResponseError;
        }
      );
    }

    function postOrder() {
      var url = apiEnvironment + '/api/routing/route';

      var config = {
        headers: {
          Authorization: 'Bearer ' + $userPreference.getAuthToken()
        }
      };

      var data = $userPreference.getPreference('advancedRouteBody');
      data = data.replaceAll('\n', '');
      data = data.replaceAll('\t', '');
      data = angular.toJson(data);
      data = JSON.parse(data); // eslint-disable-line angular/json-functions

      return $http.post(url, data, config).then(
        function successCallback(routeResponse) {
          return routeResponse.data;
        },
        function errorCallback(routeResponseError) {
          $log.error('routeResponseError', routeResponseError);
          toastr.error(routeResponseError.status + ': Error Fetching Response');

          // Unauthorized
          if (routeResponseError.status === 401) {
            $userPreference.clearLoginInfo();
          }
          return routeResponseError;
        }
      );
    }

    function getEnvironments() {
      return $http.get('../../../../assets/json/environments.json').then(function (response) {
        return response.data;
      });
    }

    function getDefaultEnvironment(environments) {

      var defaultEnvironment;

      angular.forEach(environments, function (environment) {
        if (environment.default) {
          defaultEnvironment = environment;
        }
      });

      if (angular.isUndefined(defaultEnvironment)) {
        if (angular.isDefined(environments) && environments.length > 0) {
          defaultEnvironment = environments[0];
        }
      }

      return defaultEnvironment;
    }

    function formatResponseForSummary(routeResponse) {

      var tooltips = routingConstants.routeSummary.tooltips;
      var units = routingConstants.routeSummary.units;
      var model = routeResponse.analytics.modelParameters;

      var bestVenue = model['native:best:venue'];
      var worstVenue = model['native:worst:venue'];
      var sourceAsset = model['route:source:asset'];
      var destinationAsset = model['route:result:asset'];
      var assetPair = model['price:teloneum:asset-pair'];
      var assetPairInverted = model['price:teloneum:inverted:asset-pair'];
      var bought = model['route:result:' + destinationAsset];

      // function to create a row data structure for the routing summary table
      var row = function (value, units, tooltip, tooltipParam) {

        var formattedTooltip = tooltip.replace("{0}", tooltipParam);

        return {
          value: value,
          units: units,
          tooltip: formattedTooltip
        };
      };

      // place data for each row in the summary table right on the vm, keep these accesses short as they're already buried inside markup
      var routingSummary = {
        source: sourceAsset,
        destination: destinationAsset,
        assetPair: assetPair,
        assetPairInverted: assetPairInverted,
        bought: row(bought, destinationAsset, tooltips.bought, destinationAsset),
        filledAt: row(model['price:teloneum'], assetPair + units.actual, tooltips.filledAt, destinationAsset),
        filledAtInverted: row(model['price:teloneum:inverted'], assetPairInverted + units.inverted, tooltips.filledAtInverted, destinationAsset),
        marketPrice: row(model['price:market'], assetPair + units.actual, tooltips.marketPrice, assetPair),
        marketPriceInverted: row(model['price:market:inverted'], assetPairInverted + units.inverted, tooltips.marketPriceInverted, assetPairInverted),
        slippage: row(model['price:slippage:teloneum'], units.bps, tooltips.slippage),
        bestNative: row(model['native:' + bestVenue + ':fill-price:incl:fees'], assetPair + ' @ ' + bestVenue + units.actual, tooltips.bestNative, assetPair),
        bestNativeInverted: row(model['native:' + bestVenue + ':inverted:fill-price:incl:fees'], assetPairInverted + ' @ ' + bestVenue + units.inverted, tooltips.bestNativeInverted, assetPairInverted),
        worstNative: row(model['native:' + worstVenue + ':fill-price:incl:fees'], assetPair + ' @ ' + worstVenue + units.actual, tooltips.worstNative, assetPair),
        worstNativeInverted: row(model['native:' + worstVenue + ':inverted:fill-price:incl:fees'], assetPairInverted + ' @ ' + worstVenue + units.inverted, tooltips.worstNativeInverted, assetPairInverted),
        priceImprovementVsBest: row(model['price:improvement:native:best:incl:fees'], units.bps + ' vs ' + bestVenue, tooltips.priceImprovementVsBest),
        priceImprovementVsWorst: row(model['price:improvement:native:worst:incl:fees'], units.bps + ' vs ' + worstVenue, tooltips.priceImprovementVsWorst),
        timings: {
          route: row(model['time:route'], model['time:route:units'], tooltips.timings.route),
          analytics: row(model['time:analytics'], model['time:analytics:units'], tooltips.timings.analytics),
          roundtrip: row(routeResponse.timeToCalculate, 'ms', tooltips.timings.roundtrip)
        }
      };

      return routingSummary;
    }

    function openAdvancedRouteModal() {
      return $uibModal.open({
        templateUrl: 'app/components/routing/advancedRouteModal/advancedRouteModal.html',
        size: 'md',
        controller: 'AdvancedRouteModalController as vm'
      });
    }

    function routeResponseToExecutionRequest(routeResponse) {

      var convertSegment = function (segment, index) {
        return {
          id: 'mock-id-' + index,
          externalId: 'mock-external-id-' + index,
          executedAt: new Date().toISOString(),
          segmentId: segment.segmentId,
          venue: segment.venue,
          assetPair: segment.assetPair,
          side: segment.side,
          size: segment.size,
          fee: segment.fee,
          price: segment.estimatedFillPrice
        }
      };

      var executionRequest = {
        orderId: routeResponse.order.orderId,
        executions: [

        ]
      };

      for (var i = 0; i < routeResponse.segments.length; i++) {
        executionRequest.executions.push(convertSegment(routeResponse.segments[i], i));
      }

      return executionRequest;
    }

    function postExecution(executionRequest) {
      var url = apiEnvironment + '/api/execution';

      var config = {
        headers: {
          Authorization: 'Bearer ' + $userPreference.getAuthToken()
        }
      };

      return $http.post(url, executionRequest, config).then(
        function successCallback(executionResponse) {
          return executionResponse.data;
        },
        function errorCallback(executionResponseError) {
          $log.error('executionResponseError', executionResponseError);
          toastr.error(executionResponseError.status + ': Error Fetching Response');

          // Unauthorized
          if (executionResponseError.status === 401) {
            $userPreference.clearLoginInfo();
          }
          return executionResponseError;
        }
      );
    }

    return {
      routeOrder: routeOrder,
      postOrder: postOrder,
      getEnvironments: getEnvironments,
      getDefaultEnvironment: getDefaultEnvironment,
      formatResponseForSummary: formatResponseForSummary,
      openAdvancedRouteModal: openAdvancedRouteModal,
      routeResponseToExecutionRequest: routeResponseToExecutionRequest,
      postExecution: postExecution
    }
  }

})();

(function() {
    'use strict';

    angular
        .module('teloneumUi')
        .service('routingConstants', routingConstants);

    /** @ngInject */
    function routingConstants() {

        var includesFees = " (incl. fees)";

        var routeSummary = 
        {
            labels: 
            {
                tradeSummary:               "Trade Summary",
                bought:                     "Bought",
                filledAt:                   "Filled At" + includesFees,
                filledAtInverted:           "",
                marketPrice:                "Market Price",
                marketPriceInverted:        "",
                slippage:                   "Slippage" + includesFees,
                bestNative:                 "Best Native Fill" + includesFees,
                bestNativeInverted:         "",
                worstNative:                "Worst Native Fill" + includesFees,
                worstNativeInverted:        "",
                priceImprovementVsBest:     "Price Improvement vs Best" + includesFees,
                priceImprovementVsWorst:    "Price Improvement vs Worst" + includesFees,
                timings:                    "Timings",
                route:                      "Route",
                analytics:                  "Analytics",
                roundtrip:                  "Roundtrip"
            },
            tooltips: 
            {
                bought:                     "The final result of the requested trade, including fees, in units of the destination asset: {0}.",

                filledAt:                   "The estimated fill price of the requested trade, including fees, in units of {0}.",

                filledAtInverted:           "The estimated fill price of the requested trade, including fees, in units of {0}.",

                marketPrice:                "The best market price available from exchanges within the environment. If a direct match is not found, " + 
                                            "then teloneum's synthetic market price is displayed. This value is in units of {0}",

                marketPriceInverted:        "The best market price available from exchanges within the environment. If a direct match is not found, " + 
                                            "then teloneum's synthetic market price is displayed. This value is in units of {0}",

                slippage:                   "The difference between the market price and the estimated fill price, including fees, in basis points.",

                bestNative:                 "The best estimated fill price achievable from executing the requested trade against a single exchange, " + 
                                            "within the selected environment, including fees, in units of {0}. This value is only available when the " + 
                                            "asset pair is natively available on an exchange within the selected environment.",

                bestNativeInverted:         "The best estimated fill price achievable from executing the requested trade against a single exchange, " +
                                            "within the selected environment, including fees, in units of {0}. This value is only available when the " +
                                            "asset pair is natively available on an exchange within the selected environment.",

                worstNative:                "The worst estimated fill price achievable from executing the requested trade against a single exchange, " + 
                                            "within the selected environment, including fees, in units of {0}. This value is only available when the " + 
                                            "asset pair is natively available on an exchange within the selected environment.",

                worstNativeInverted:        "The worst estimated fill price achievable from executing the requested trade against a single exchange, " + 
                                            "within the selected environment, including fees, in units of {0}. This value is only available when the " + 
                                            "asset pair is natively available on an exchange within the selected environment.",

                priceImprovementVsBest:     "The difference in estimated fill prices between teloneum and the best native fill, including fees, " + 
                                            "in basis points. This value represents the net savings achieved from using teloneum as compared to a " + 
                                            "simple order router that routes the entire order to the exchange providing the best estimated fill price.",

                priceImprovementVsWorst:    "The difference in estimated fill prices between teloneum and the worst native fill, including fees, " + 
                                            "in basis points. This value represents the net savings achieved from using teloneum as compared to a " +
                                            "really bad order router that routes the entire order to the exchange providing the worst estimated fill price.",

                timings: 
                {
                    route:                  "The total amount of time, in milliseconds, that the router spent resolving the optimal order route for " +
                                            "the provided environments. Larger, more complicated environments will take longer to compute while also " +
                                            "providing increased price improvement.",

                    analytics:              "The total amount of time, in milliseconds, that the post-route analysis module spent computing the routing " + 
                                            "metrics. In order to compute these metrics, the analytics module must evaluate all possible matching native " +
                                            "routes to provide the best/worst comparisons. Analysis is optionally performed by the API, and in a production " +
                                            "setting, it is recommened to not perform the post-route analysis to improve response times.",

                    roundtrip:              "The total amount of time, in milliseconds, for the request to roundtrip. This is measured by computing the time " +
                                            "difference between the request being sent and the response being received."
                }
            },
            units: 
            {
                bps:        "bps",
                ms:         "ms",
                actual:     " (actual)",
                inverted:   " (inverted)"
            }
        };


        return {
            routeSummary: routeSummary
        }
    }

  })();
(function() {
  'use strict';

  angular
    .module('teloneumUi')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('teloneumUi')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
    'use strict';
  
    angular
        .module('teloneumUi')
        .service('loginService', loginService);
  
    /** @ngInject */
    function loginService($log, $http, $q, $state, $timeout, $userPreference, $loadingService, environmentService) {         

        var apiEnvironment = environmentService.getApiPath();

        function loginUser(credentials) {            
            var url = apiEnvironment + '/api/user/auth';

            $loadingService.setIsLoading(true);
            return $http.post(url, credentials).then(function(response){
                $userPreference.processLoginResponse(response.data);
                $loadingService.setIsLoading(false);                       
                return response.data;
            }, function errorCallback(errorResponse){
                $log.info('loginUser errorCallback', errorResponse);
                $loadingService.setIsLoading(false);
                return errorResponse.data;
            });
        }

        function logoutUser() {
            $userPreference.clearLoginInfo();            
        }

        function userIsAuthenticated() {
                        
            var userIsAuthenticated =  $userPreference.userIsAuthenticated();            
            return userIsAuthenticated;
        }

        function skipIfAuthenticated() {            
            var defer = $q.defer();
            
            if(userIsAuthenticated())
            {
                $log.info('skipIfAuthenticated', 'reject');
                defer.reject();
            } 
            else
            {
                $log.info('skipIfAuthenticated', 'resolve');
                defer.resolve();
            }
            return defer.promise;
        }
           
        function redirectIfNotAuthenticated() {
            var defer = $q.defer();
            
            if(userIsAuthenticated()) 
            {
                $log.info('redirectIfNotAuthenticated', 'resolve');
                defer.resolve();
            } 
            else 
            {
                $log.info('redirectIfNotAuthenticated', 'reject');
                $timeout(function () {
                    $state.go('login');
                });
                defer.reject();
            }
            return defer.promise;
        }        

        return {
            loginUser: loginUser,
            userIsAuthenticated: userIsAuthenticated,
            skipIfAuthenticated: skipIfAuthenticated,
            redirectIfNotAuthenticated: redirectIfNotAuthenticated,
            logoutUser: logoutUser
        }
    }
  
  })();
  
(function() {
  'use strict';

  angular
    .module('teloneumUi')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('teloneumUi')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1553041240181;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function() {

    'use strict';        

    angular
        .module('teloneumUi')
        .factory('$userPreference', userPreferenceService);
        
    /** @ngInject */
    function userPreferenceService($localStorage, $log, $timeout, $window) {

        var storageKey;
        var userPreferences;        

        function setPreference(preference, value) {
            initPreferences();
            userPreferences[preference] = value;
            $log.info('userPreferences[preference]', userPreferences[preference]);
            $localStorage.setObject(storageKey, userPreferences);
        }

        function getPreference(preference, defaultValue) {
            initPreferences();            
            if (angular.isDefined(userPreferences[preference])) {                
                return userPreferences[preference];
            } else {
                if(defaultValue){
                    userPreferences[preference] = defaultValue;
                }else{
                    userPreferences[preference] = false;
                }
                
                $localStorage.setObject(storageKey, userPreferences);
                return userPreferences[preference];
            }
        }

        function initPreferences(){
            if(!storageKey) {
                storageKey = 'userPreferences'; // may want to consider appending user key to support multiple user preferences
                userPreferences = $localStorage.getObject(storageKey);
                if(angular.isUndefined(userPreferences)) {
                    userPreferences = {};
                    $localStorage.setObject(storageKey, userPreferences);
                }
            }
        }        

        function processLoginResponse(loginResponse){
            $log.info('processLoginResponse', loginResponse);

            setPreference('authToken', loginResponse.token);
            setPreference('email', loginResponse.email);
            setPreference('userId', loginResponse.user);                        
        }

        function getAuthToken(){
            return getPreference('authToken', null);            
        }

        function getEmail(){
            return getPreference('email', null);            
        }

        function getUserId(){
            return getPreference('userId', null);            
        }

        function userIsAuthenticated(){
            var token = getAuthToken();
            var authenticated = (angular.isDefined(token) && (token !== null) && token);
            $log.info('authenticated', authenticated);
            return authenticated;
        }

        function clearLoginInfo(){
            initPreferences();
            $localStorage.remove(storageKey);
            userPreferences = undefined;
            $log.info('clearLoginInfo');
            $timeout(function(){                
                $window.location.reload();
            }, 2000);
        }

        return {
            getPreference: getPreference,
            setPreference: setPreference,
            processLoginResponse: processLoginResponse,
            getAuthToken: getAuthToken,
            getEmail: getEmail,
            getUserId: getUserId,
            userIsAuthenticated: userIsAuthenticated,
            clearLoginInfo: clearLoginInfo
        };
    }

})();
(function() {
    'use strict';
  
    angular
        .module('teloneumUi')
        .service('sha256', sha256Service);
  
    /** @ngInject */
    function sha256Service($window) {              
        return $window.sha256        
    }
  
  })();
  
(function() {

    'use strict';        

    angular
        .module('teloneumUi')
        .factory('$sessionStorage', sessionStorageService);
        
    /** @ngInject */
    function sessionStorageService($window) {

        function get(key, defaultValue) {
            var result = angular.fromJson($window.sessionStorage.getItem(key));
            if (result) {
                return result.value;
            } else {
                if (angular.isDefined(defaultValue)) {
                    return defaultValue;
                } else {
                    return {};
                }
            }

        }

        function set(key, value) {
            var storageItem = {
                value: value
            };

            $window.sessionStorage.setItem(key, angular.toJson(storageItem));
        }

        function remove(key) {
            $window.sessionStorage.removeItem(key);
        }

        return {
            getItem: get,
            setItem: set,
            removeItem: remove
        };

    }

})();
(function() {

    'use strict';        

    angular
        .module('teloneumUi')
        .factory('$localStorage', localStorageService);
        
    /** @ngInject */
    function localStorageService($window) {

        function set(key, value) {
            if (!isLocalStorageAvailable()) {
                return;
            }
            $window.localStorage[key] = value;
        }

        function get(key, defaultValue) {
            if (!isLocalStorageAvailable()) {
                return null;
            }
            return $window.localStorage[key] || defaultValue;
        }

        function setObject(key, value) {
            if (!isLocalStorageAvailable()) {
                return;
            }
            $window.localStorage[key] = angular.toJson(value);
        }

        function getObject(key) {
            if (!isLocalStorageAvailable()) {
                return null;
            }
            if (angular.isDefined($window.localStorage[key])) {
                return angular.fromJson($window.localStorage[key]);
            } else {
                return undefined;
            }

        }

        function getBoolean(key) {
            if (!isLocalStorageAvailable()) {
                return false;
            }
            return localStorage[key] === 'true';
        }

        function remove(key) {
            $window.localStorage.removeItem(key);
        }

        function isLocalStorageAvailable() {
            return typeof(Storage) !== 'undefined';
        }

        return {
            get: get,
            getItem: get,
            getBoolean: getBoolean,
            getObject: getObject,
            isLocalStorageAvailable: isLocalStorageAvailable,
            remove: remove,
            set: set,
            setItem: set,
            setObject: setObject
        };

    }

})();
(function() {

    'use strict';        

    angular
        .module('teloneumUi')
        .factory('$loadingService', loadingService);
        
    /** @ngInject */
    function loadingService() {

        var isLoading = false;
        
        function setIsLoading(loading){
            isLoading = loading;
        }

        function getIsLoading(){
            return isLoading;
        }

        return {
            setIsLoading: setIsLoading,
            getIsLoading: getIsLoading
        };
    }

})();
(function() {

    'use strict';        

    angular
        .module('teloneumUi')
        .factory('httpInterceptorService', httpInterceptorService);
        
    /** @ngInject */
    function httpInterceptorService($log) {        

        var requestInterceptor = {
            request: function(request) {                
                return request;
            },
            response: function(response) {
                $log.info('Response Intercepted', response);
                if(response.status === 401) {                  
                    // TODO Force Logout any time this happens
                    $log.error('Unauthorized User');                                    
                }
                return response;
            }
        };

        return requestInterceptor;
    }

})();
(function () {

  'use strict';

  angular
    .module('teloneumUi')
    .factory('environmentService', environmentService);

  /** @ngInject */
  function environmentService($log, $window, apiEnvironment) {

    var apiPath = undefined;

    var getApiPath = function () {      

      if (angular.isUndefined(apiPath)) {
        
        if ($window.location.host.indexOf('localhost') !== -1) {
          // IF RUNNING ON LOCALHOST USE apiEnvironment as configured
          apiPath = apiEnvironment;
          $log.info('Configured for LOCALHOST using', apiPath);
        }
        else {          
          // ELSE WE Use the same url prefixed with API for the environment always with HTTPS
          apiPath = 'https://api.' + $window.location.host;
          $log.info('API Configured', apiPath);
        }
      }
      
      return apiPath;
    };

    return {
      getApiPath: getApiPath
    };
  }

})();
(function() {
  'use strict';

  angular
    .module('teloneumUi')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('teloneumUi')
    .config(routerConfig);

  // TODO https://medium.com/@petehouston/protect-authentication-routes-in-angular-ui-router-and-satellizer-7745257a7e6

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/pages/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
        data: {
          bodyClasses: 'auth'
        },
        resolve: {
          skipIfAuthenticated: ['loginService', function(loginService){
            return loginService.skipIfAuthenticated();
          }]
        }
      })
      .state('logout', {
        url: '/logout',
        templateUrl: 'app/pages/logout/logout.html',
        controller: 'LogoutController',
        controllerAs: 'vm',
        data: {
          bodyClasses: 'app'
        },
        resolve: {          
          redirectIfNotAuthenticated: ['loginService', function(loginService){
            return loginService.redirectIfNotAuthenticated();
          }]
        }
      })
      .state('demo', {
        url: '/demo',
        templateUrl: 'app/pages/demo/demo.html',
        controller: 'DemoController',
        controllerAs: 'vm',
        data: {
          bodyClasses: 'app'
        },
        resolve: {          
          redirectIfNotAuthenticated: ['loginService', function(loginService){
            return loginService.redirectIfNotAuthenticated();
          }]
        }
      })
      .state('default', {
        url: '/',
        templateUrl: 'app/pages/demo/demo.html',
        controller: 'DemoController',
        controllerAs: 'vm',
        data: {
          bodyClasses: 'app'
        },
        resolve: {          
          redirectIfNotAuthenticated: ['loginService', function(loginService){
            return loginService.redirectIfNotAuthenticated();
          }]
        }
      })
      .state('technologies', {
        url: '/tech',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        data: {
          bodyClasses: 'app'
        },
        resolve: {
          redirectIfNotAuthenticated: ['loginService', function(loginService){
            return loginService.redirectIfNotAuthenticated();
          }]
        }
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('teloneumUi')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('apiEnvironment', 'https://api.beta.teloneum.1konto.com');
})();

(function() {
  'use strict';

  angular
    .module('teloneumUi')
    .config(config);

  /** @ngInject */
  function config($logProvider, $httpProvider, toastrConfig) {
    
    // Enable log
    $logProvider.debugEnabled(true);

    // Add the Http Interceptors
    $httpProvider.interceptors.push('httpInterceptorService');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

(function() {
    'use strict';
  
    angular
      .module('teloneumUi')
      .controller('AppController', AppController);
  
    /** @ngInject */
    function AppController($scope, $loadingService) {
        var vm = this;
      
        vm.bodyClasses = 'default';

        // this'll be called on every state change in the app
        $scope.$on('$stateChangeSuccess', function(event, toState){
            if (angular.isDefined(toState.data.bodyClasses)) {
                vm.bodyClasses = toState.data.bodyClasses;
                return;
            }
            vm.bodyClasses = 'default';
        });

        var loadingChange = function(){
            return $loadingService.getIsLoading();
        }

        $scope.$watch(loadingChange, function(newValue) {            
            vm.showLoadingOverlay = newValue;            
        });
    }
  })();
  
angular.module("teloneumUi").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=container><div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=lead><img src=assets/images/yeoman.png alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=main.classAnimation><button type=button class=\"btn btn-lg btn-success\" ng-click=main.showToastr()>Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=row><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=thumbnail><img class=pull-right ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=caption><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href={{awesomeThing.url}}>{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/components/topNavigation/topNavigation.html","<nav class=\"navbar navbar-static-top navbar-inverse telo-top-nav\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=#>1 Konto</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><!--\n            <ul class=\"nav navbar-nav\">\n                <li class=\"active\"><a ng-href=\"#\">Home</a></li>\n                <li><a ng-href=\"#\">About</a></li>\n                <li><a ng-href=\"#\">Contact</a></li>\n            </ul>\n            --><ul class=\"nav navbar-nav navbar-right\"><li>Logged In as: <span class=bold>{{::vm.loggedInUser}}</span></li><li><a class=\"btn btn-default logout-btn\" href=/#/logout><i class=\"fas fa-sign-out-alt\"></i> Logout</a></li></ul></div></div></nav>");
$templateCache.put("app/pages/demo/demo.html","<div class=demo-page><telo-top-navigation></telo-top-navigation><div style=\"padding: 10px\"><h1>Routing Demo <span class=\"timestamp pull-right\">{{vm.routeResponse.timestamp | date:\'MM/dd/yyyy h:mm:ss a\'}}</span></h1><br><telo-routing-form route-response=vm.routeResponse></telo-routing-form><br><uib-tabset active=active><uib-tab index=0 heading=\"Tabular Response\"><div ng-if=\"vm.routeResponse.segments.length > 0\"><telo-routing-table route-response=vm.routeResponse></telo-routing-table><telo-routing-summary route-response=vm.routeResponse></telo-routing-summary></div></uib-tab><uib-tab index=1 heading=\"JSON Response\"><json-formatter json=vm.routeResponse open></json-formatter></uib-tab></uib-tabset><button class=\"btn btn-default pull-right\" ng-if=vm.routeResponse.segments.length style=\"margin-top: 20px; margin-bottom: 20px\" ng-click=vm.executeRoute()>Execute Route</button><div ng-if=vm.executionResponse><json-formatter json=vm.executionResponse open></json-formatter></div></div></div>");
$templateCache.put("app/pages/login/login.html","<div class=\"container login-page\"><div class=row><div class=\"col-md-8 col-md-offset-2\"><telo-login-form></telo-login-form></div></div></div>");
$templateCache.put("app/pages/logout/logout.html","<div style=\"padding: 10px\"><h1>See you next time!</h1></div>");
$templateCache.put("app/components/login/loginForm/loginForm.html","<form class=columns name=vm.loginForm novalidate><div class=\"column col-10 col-mx-auto\"><h3 class=text-center>Welcome to Teloneum!</h3><div class=loginForm><!-- EMAIL INPUT --><div class=form-group><label for=emailAddress>Email</label><input id=emailAddress type=email class=form-control placeholder=Email ng-required=true ng-model=vm.email></div><!-- PASSWORD INPUT --><div class=form-group><label for=password>Password</label><input id=password type=password class=form-control placeholder=Password ng-required=true ng-model=vm.password></div><!-- REMEMBER ME --><div class=\"form-group hide\"><div class=checkbox><input type=checkbox id=rememberMe ng-model=vm.rememberMe><label for=rememberMe>Keep me signed in on this computer</label></div></div><!-- SIGN IN BUTTON --> <button class=\"btn btn-primary btn-block\" ng-click=vm.login() ng-disabled=vm.disableSubmit>Sign in</button></div></div></form>");
$templateCache.put("app/components/routing/advancedRouteModal/advancedRouteModal.html","<div class=advanced-route-modal><div class=modal-header><h3 class=modal-title id=modal-title>Advanced Routing</h3></div><div class=modal-body id=modal-body><p>Configure an advanced route</p><textarea name=routeBody spellcheck=false class=form-control ng-model=vm.advancedRouteBody placeholder=\'{\n  \"size\": 0.5,\n  \"source\": \"BTC\",\n  \"destination\": \"USD\",\n  \"mode\": \"asynchronous\",\n  \"orderType\": \"MarketOrder\",\n  \"environmentId\": \"a9f5695dcafe5953993be8810f24af3c\",\n  \"arguments\": {\n    \"analyze\": true,\n      \"execute\": false,\n      \"log-fill-messages\": true\n  },\n    \"balances\": {\n      \"binance\": {\n          \"BTC\": 2.769094018785,\n          \"ETH\": 51.0,\n          \"LTC\": 2.145,\n          \"USDT\": 23363.96703621825,\n          \"XRP\": 6332.2\n      },\n      \"liquid\": {\n          \"BTC\": 2.67006697,\n          \"ETH\": 51.0,\n          \"LTC\": 2.145,\n          \"USD\": 110417.0,\n          \"USDT\": 25214.0488402453783,\n          \"XRP\": 1562.0\n      }\n  }\n}\'></textarea></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=vm.saveAdvancedRoute()>Route</button> <button class=\"btn btn-link\" type=button ng-click=vm.cancel()>Cancel</button></div></div>");
$templateCache.put("app/components/routing/routingForm/routingForm.html","<form class=\"routing-form form-inline\"><div class=form-group><label for=size>Size</label><input type=text class=form-control id=size placeholder=\"Ex. 100\" value=100 ng-model=vm.inputs.size></div><div class=form-group><label for=source>Source</label><input type=text class=form-control id=source placeholder=\"Ex. ETH\" ng-model=vm.inputs.source></div><div class=form-group><label for=dest>Destination</label><input type=text class=form-control id=dest placeholder=\"Ex. BTC\" value=BTC ng-model=vm.inputs.dest></div><div class=form-group><label for=environment>Environment</label><select name=environment id=environment class=\"form-control dropdown\" ng-model=vm.inputs.environmentId ng-change=vm.changeEnvironment() ng-options=\"option.environmentId as option.description for option in ::vm.environmentOptions\"></select><input type=text class=\"form-control extended\" id=environment placeholder=\"Environment Id\" ng-model=vm.inputs.environment ng-if=\"vm.inputs.environmentId === \'custom\'\"></div><button type=submit class=\"btn btn-primary\" ng-click=vm.routeOrder()>Route</button> <button class=\"btn btn-link\" ng-click=vm.openAdvancedRouteModal()>Advanced</button></form>");
$templateCache.put("app/components/routing/routingSummary/routingSummary.html","<table class=\"routing-summary table\"><thead><tr><th>{{::vm.labels.tradeSummary}}</th><th></th><th></th></tr></thead><tbody><tr><th>{{::vm.labels.bought}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.bought.tooltip}} tooltip-placement=right></i></th><td>{{vm.summary.bought.value}}</td><th><span>{{vm.summary.bought.units}}</span></th></tr><tr><th>{{::vm.labels.filledAt}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.filledAt.tooltip}} tooltip-placement=right></i></th><td>{{vm.summary.filledAt.value}}</td><th><span>{{vm.summary.filledAt.units}}</span></th></tr><tr><th>{{::vm.labels.filledAtInverted}}</th><td>{{vm.summary.filledAtInverted.value}}</td><th><span>{{vm.summary.filledAtInverted.units}}</span></th></tr><tr><th>{{::vm.labels.marketPrice}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.marketPrice.tooltip}} tooltip-placement=right></i></th><td>{{vm.summary.marketPrice.value}}</td><th><span>{{vm.summary.marketPrice.units}}</span></th></tr><tr><th>{{::vm.labels.marketPriceInverted}}</th><td>{{vm.summary.marketPriceInverted.value}}</td><th><span>{{vm.summary.marketPriceInverted.units}}</span></th></tr><tr><th>{{::vm.labels.slippage}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.slippage.tooltip}} tooltip-placement=right></i></th><td>{{vm.summary.slippage.value | number:2}}</td><th><span>{{vm.summary.slippage.units}}</span></th></tr><tr><th>{{::vm.labels.bestNative}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.bestNative.tooltip}} tooltip-placement=right></i></th><td>{{vm.summary.bestNative.value}}</td><th><span>{{vm.summary.bestNative.units}}</span></th></tr><tr><th>{{::vm.labels.bestNativeInverted}}</th><td>{{vm.summary.bestNativeInverted.value}}</td><th><span>{{vm.summary.bestNativeInverted.units}}</span></th></tr><tr><th>{{::vm.labels.worstNative}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.worstNative.tooltip}} tooltip-placement=right></i></th><td>{{vm.summary.worstNative.value}}</td><th><span>{{vm.summary.worstNative.units}}</span></th></tr><tr><th>{{::vm.labels.worstNativeInverted}}</th><td>{{vm.summary.worstNativeInverted.value}}</td><th><span>{{vm.summary.worstNativeInverted.units}}</span></th></tr><tr><th>{{::vm.labels.priceImprovementVsBest}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.priceImprovementVsBest.tooltip}} tooltip-placement=right></i></th><td>{{vm.summary.priceImprovementVsBest.value | number:2}}</td><th><span>{{vm.summary.priceImprovementVsBest.units}}</span></th></tr><tr><th>{{::vm.labels.priceImprovementVsWorst}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.priceImprovementVsWorst.tooltip}} tooltip-placement=right></i></th><td>{{vm.summary.priceImprovementVsWorst.value | number:2}}</td><th><span>{{vm.summary.priceImprovementVsWorst.units}}</span></th></tr><tr><th>{{::vm.labels.timings}}</th><td></td><th></th></tr><tr><th>{{::vm.labels.route}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.timings.route.tooltip}} tooltip-placement=right></i></th><td>{{vm.summary.timings.route.value}}</td><th><span>{{vm.summary.timings.route.units}}</span></th></tr><tr><th>{{::vm.labels.analytics}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.timings.analytics.tooltip}}></i></th><td>{{vm.summary.timings.analytics.value}}</td><th><span>{{vm.summary.timings.analytics.units}}</span></th></tr><tr><th>{{::vm.labels.roundtrip}} <i class=\"fas fa-info-circle\" uib-tooltip={{vm.summary.timings.roundtrip.tooltip}}></i></th><td>{{vm.summary.timings.roundtrip.value}}</td><th><span>{{vm.summary.timings.roundtrip.units}}</span></th></tr></tbody></table>");
$templateCache.put("app/components/routing/routingTable/routingTable.html","<table class=\"table table-striped\"><thead><tr><th>Segment</th><th>Venue</th><th>Direction</th><th>Size</th><th>Asset Pair</th><th>Estimated Fill (inc. Fee)</th><th>Fee</th></tr></thead><tbody><tr ng-repeat=\"record in vm.routeResponse.segments\"><td>{{$index + 1}}</td><td>{{record.venue}}</td><td>{{record.side}}</td><td>{{record.size}}</td><td>{{record.assetPair}}</td><td>{{record.estimatedFillPrice}}</td><td>{{record.fee}}</td></tr></tbody></table>");}]);